interface IconProps {
  className?: string;
}

const AddressIcon: React.FC<IconProps> = (props) => {
  return (
    <>
      <svg
        className={props.className}
        width="32"
        height="32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23 13c0 1.755-.687 3.69-1.716 5.58-1.022 1.879-2.335 3.629-3.48 4.994-.967 1.152-2.641 1.152-3.608 0-1.145-1.365-2.458-3.116-3.48-4.993C9.686 16.689 9 14.755 9 13a7 7 0 1 1 14 0Z"
          className="stroke-current"
          strokeWidth="2"
        />
        <circle className="stroke-current" cx="16" cy="13" r="1" strokeWidth="2" />
      </svg>
    </>
  );
};

export default AddressIcon;
